<template>
  <el-form-item
    :label="label"
    class="select"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="select"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :required="required"
      :options="options"
      :clearable="false"
      :filterable="false"
    >
      <el-option v-if="!required" label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span>
        <span style="float: left; margin-left: 10px">{{item.label}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'select'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    codeId: {
      type: String,
      default: ''
    }
    // options: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    select: {
      get () {
        return this.value
      },
      set (select) {
        this.$emit('change', select)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const selectList = await this.loadCode()
    const selectListSet = selectList.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = selectListSet
    this.optionsOriginal = selectListSet
    // const selectListSet = [...new Set(selectList.map((x) => x.code_value))]
    // this.options = selectListSet.map((x) => { return { value: x, label: x } })
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: this.codeId } })
          .then((res) => {
            sessionStorage.setItem('selectList', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('selectList'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  ::v-deep .el-form-item__content {
    width: 8em;
  }
}
</style>
